import { NavbarComponent } from "../navbar/NavbarComponent";
import { useEffect, useState } from "react";
import "./Hero.css";
import {Link} from "react-router-dom";
import {Button} from "react-bootstrap";

export function Hero() {
  const [word, setWord] = useState("");
  const target = "You have found your new Developer";

  useEffect(() => {

    generate();
    // eslint-disable-next-line
  }, []);

  const generate = () => {
    let timer;
    let i = -1;
    timer = setInterval(() => {
      i++;
      if (i === target.length - 1) clearInterval(timer);
      setWord((prev) => prev + target[i]);
    }, 80);
  };

  return (
    <div className="hero">
      <NavbarComponent />
      <div className="hero-content">
        <p className="hero-eyebrow">{"// full-stack developer"}</p>
        <h1 className="hero-typed">{word}</h1>
        <p className="hero-sub">
          Building a custom solution to fit your desired web-presence using
          industry standard technologies.
        </p>
        <Link to="/work">
          <Button className="hero-button">Examples</Button>
        </Link>
      </div>
    </div>
  );
}
